import { Component, OnInit } from '@angular/core';
import { UserService } from "../services/user.service"
import { MechanicsService } from "../services/mechanics.service"
import { UtilsService } from "../services/utils.service"

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.styl'],
    standalone: false
})
export class HeaderComponent {

	public uitheme = "omega"

	public uithemes: Object[] = ["bootstrap", "cruze", "cupertino", "darkness", "flick", "home", "kasper", "lightness", "ludvig", "omega", "pepper-grinder", "redmond", "rocket", "south-street", "trontastic", "voclain"].map(uitheme => {
		return {
			label: uitheme,
			value: uitheme
		}
	})


	constructor(public us: UserService,
		public ms: MechanicsService,
		public utils: UtilsService) {

	}

}


